import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetLaborDemandQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  startDate: Types.Scalars['DateTime']['input'];
  endDate: Types.Scalars['DateTime']['input'];
}>;


export type GetLaborDemandQuery = { __typename?: 'Query', laborDemand: { __typename?: 'LaborDemandSummary', totalPlannedHours: number, totalPlannedCost: number, entries: Array<{ __typename?: 'LaborDemandEntry', date: Types.TDateISO, triggerDate?: Types.TDateISO | null, blockName: string, taskEventTypeName: string, taskEventTypeId: string, plannedHours: number, plannedCost: number, productionJobId: string, productionJobName?: string | null, quantity: number, eventSource: Types.LaborDemandEventSource, calcSteps: Array<{ __typename?: 'LaborDemandCalcStep', code: string, context: Array<{ __typename?: 'LaborDemandCalcStepContextEntry', key: string, value: string }> }> }> } };


export const GetLaborDemandDocument = new TypedDocumentString(`
    query GetLaborDemand($siteLocationId: String!, $startDate: DateTime!, $endDate: DateTime!) {
  laborDemand(
    siteLocationId: $siteLocationId
    startDate: $startDate
    endDate: $endDate
  ) {
    totalPlannedHours
    totalPlannedCost
    entries {
      date
      triggerDate
      blockName
      taskEventTypeName
      taskEventTypeId
      plannedHours
      plannedCost
      productionJobId
      productionJobName
      quantity
      eventSource
      calcSteps {
        code
        context {
          key
          value
        }
      }
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetLaborDemand: build.query<GetLaborDemandQuery, GetLaborDemandQueryVariables>({
      query: (variables) => ({ document: GetLaborDemandDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetLaborDemandQuery, useLazyGetLaborDemandQuery } = injectedRtkApi;
